/* ------------------------------Daktela chat bot  -------------------------------*/
    // daktela chat bot
if (window.location.pathname.includes("contact-us")) {
var daktelaGuiConfig = {
  server: 'https://comfortclick.daktela.com/',
  accessToken: '4930r22023299s3p5orn953snsqr808s',
};
var daktelaWeb = null;
var daktelaScriptEl = document.createElement('script');

// Set non-src attributes first — these are fine via direct assignment
daktelaScriptEl.type = 'text/javascript';
daktelaScriptEl.async = true;
daktelaScriptEl.charset = 'utf-8';

// onload callback is identical to original — untouched
daktelaScriptEl.onload = function () {
  if (typeof daktelaGui === 'undefined') return;
  daktelaWeb = new daktelaGui();
  daktelaWeb.init(daktelaGuiConfig);
};

// src set via property assignment (not setAttribute) so the DELAY
// interceptor in theme.liquid catches it and holds until first interaction
daktelaScriptEl.src = daktelaGuiConfig.server + 'external/web/web.js';

document.getElementsByTagName('head')[0].appendChild(daktelaScriptEl);
}
/* ------------------------------Timer announcemnet bar  -------------------------------*/
 var countdowns = document.querySelectorAll('.countdown');

  var updateCountdown = (countdown) => {
    const startTime = new Date(countdown.dataset.start).getTime();
    const endTime = new Date(countdown.dataset.end).getTime();
    const now = new Date().getTime();

    if (now < startTime || now > endTime) {
      countdown.style.display = 'none';
      return;
    }

    countdown.style.display = 'flex';

    const distance = endTime - now;

    if (distance <= 0) {
      countdown.style.display = 'none';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    countdown.querySelector('.hours').textContent = String(hours).padStart(2, '0');
    countdown.querySelector('.minutes').textContent = String(minutes).padStart(2, '0');
    countdown.querySelector('.seconds').textContent = String(seconds).padStart(2, '0');

    const daysUnit = countdown.querySelector('.days').closest('.time-unit');
    const daysColon = daysUnit.nextElementSibling;

    if (days === 0) {
      daysUnit.style.display = 'none';
      if (daysColon && daysColon.classList.contains('colon')) {
        daysColon.style.display = 'none';
      }
    } else {
      daysUnit.style.display = 'flex';
      if (daysColon && daysColon.classList.contains('colon')) {
        daysColon.style.display = 'inline';
      }
      countdown.querySelector('.days').textContent = String(days).padStart(2, '0');
    }
  };

  var runCountdowns = () => {
    countdowns.forEach(countdown => updateCountdown(countdown));
  };

  runCountdowns();
  setInterval(runCountdowns, 1000);


/* ------------------------------accordian footer -------------------------------*/

/**accordian footer (responsive)**/
(function () {
  function initFooterCollapse() {
    if (window.innerWidth >= 820) return;

    var headings = document.querySelectorAll('.grid .footer-block__heading');

    if (!headings.length) {
      var observer = new MutationObserver(function (mutations, obs) {
        var newHeadings = document.querySelectorAll('.grid .footer-block__heading');
        if (newHeadings.length) {
          obs.disconnect();
          initFooterCollapse();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      return;
    }

    function handleCollapse(heading) {
      if (heading.classList.contains('block-collapsed')) {
        headings.forEach(function (item) {
          item.classList.add('block-collapsed');
          item.setAttribute('aria-expanded', 'false');
        });
        heading.classList.remove('block-collapsed');
        heading.setAttribute('aria-expanded', 'true');
      } else {
        heading.classList.add('block-collapsed');
        heading.setAttribute('aria-expanded', 'false');
      }
    }

    headings.forEach(function (heading, index) {
      // prevent double init
      if (heading.dataset.collapseInit) return;
      heading.dataset.collapseInit = 'true';

      heading.classList.add('block-collapsed');
      heading.setAttribute('role', 'button');
      heading.setAttribute('aria-expanded', 'false');
      heading.setAttribute('tabindex', '0');

      if (heading.nextElementSibling) {
        heading.nextElementSibling.setAttribute('id', 'footer-block-index-' + index);
        heading.setAttribute('aria-controls', 'footer-block-index-' + index);
      }

      heading.addEventListener('click', function () { handleCollapse(heading); });
      heading.addEventListener('keypress', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          handleCollapse(heading);
        }
      });
    });
  }

  // run immediately if DOM ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterCollapse);
  } else {
    initFooterCollapse();
  }
})();

/* ------------------------------Toggle password -------------------------------*/
document.addEventListener("click", function (event) {
  // Check if the clicked element is the 'eyeIcon'
  if (event.target.classList.contains("newFieldIcon-passwordEye")) {
    // Toggle the eye icon state
    event.target.classList.toggle("fa-eye");
    event.target.classList.toggle("fa-eye-slash");
    event.target.classList.toggle("showPassword");

    // Find the input element associated with this icon using the `toggle` attribute
    const inputSelector = event.target.getAttribute("toggle");
    if (inputSelector) {
      const input = document.querySelector(inputSelector);

      if (input) {
        // Toggle the input type between 'password' and 'text'
        input.type = input.type === "password" ? "text" : "password";
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.pathname;
  // ✅ Remove OTP flag if not on /account or /login page
  if (!currentUrl.includes("/account") && !currentUrl.includes("/login")) {
    sessionStorage.removeItem("hasShownOtp");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const currentURL = window.location.href;
  const pageTitle = document.title;

  const shareButton = document.querySelector(".shareButton.main");
  const shareGroup = document.querySelector(".groupButton2");

  if (shareButton && shareGroup) {
    shareButton.addEventListener("click", function () {
      shareGroup.classList.toggle("active");
    });

    document.addEventListener("click", function (e) {
      if (!shareButton.contains(e.target) && !shareGroup.contains(e.target)) {
        shareGroup.classList.remove("active");
      }
    });
  }

  const shareButtons = document.querySelectorAll(".social-button");
  shareButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const platform = button.getAttribute("data-platform");

      let shareURL = "";
      switch (platform) {
        case "facebook":
          shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
          break;
        case "twitter":
          shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}&text=${encodeURIComponent(pageTitle)}`;
          break;
        case "linkedin":
          shareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentURL)}`;
          break;
        case "pinterest":
          shareURL = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentURL)}&description=${encodeURIComponent(pageTitle)}`;
          break;
        case "whatsapp":
          shareURL = `https://wa.me/?text=${encodeURIComponent(pageTitle + " " + currentURL)}`;
          break;
        case "email":
          shareURL = `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(currentURL)}`;
          break;
        case "copy":
          navigator.clipboard.writeText(currentURL);
          return;
      }

      if (shareURL) {
        window.open(shareURL, "_blank", "noopener,noreferrer");
      }
    });
  });
});



// -------------------------------------------Register page D.O.B-------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const dayDropdown = document.getElementById("select-day");
  const monthDropdown = document.getElementById("select-month");
  const yearDropdown = document.getElementById("select-year");

  if (!dayDropdown || !monthDropdown || !yearDropdown) {
    console.error("Dropdown elements not found!");
    return;
  }

  for (let day = 1; day <= 31; day++) {
    let option = document.createElement("option");
    option.value = day;
    option.textContent = day;
    dayDropdown.appendChild(option);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  months.forEach((month, index) => {
    let option = document.createElement("option");
    option.value = index + 1;
    option.textContent = month;
    monthDropdown.appendChild(option);
  });

  const currentYear = new Date().getFullYear();
  const startYear = 1920;

  for (let year = currentYear; year >= startYear; year--) {
    let option = document.createElement("option");
    option.value = year;
    option.textContent = year;
    yearDropdown.appendChild(option);
  }
});

/* --------------------------------------------------- END ----------------------------------------------------*/

// Account mobile nav
if (window.innerWidth <= 750) {
  const navTrigger = document.getElementById("navTrigger");
  const navList = document.querySelector(".profile-navigation");

  navList?.classList.add("hidden");

  navTrigger?.addEventListener("click", function () {
    navList.classList.toggle("hidden");
    navTrigger.classList.toggle("navTriggerActive");
  });

  const navListItems = document.querySelectorAll(".profile-navigation li a");
  navListItems?.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const content = this.innerHTML;
      navTrigger.innerHTML = content; // Update innerHTML of navTrigger
      navList.classList.add("hidden");
      navTrigger.classList.toggle("navTriggerActive");
    });
  });
}

// Custom js for Reinitializing Customer also Bought section after adding Discount.
if (window.location.href.includes('cart')) {
  document.addEventListener('DOMContentLoaded', () => {
    // Observe for DOM changes from 3rd-party app
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          // Re-initialize UI after DOM change
          initializeCarousel();
        }
      }
    });

    // Start observing the document body (or a more specific parent if you know it)
    const target = document.body;
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });
}

// OTP login show
// document.addEventListener("DOMContentLoaded", function () {
//   const currentUrl = window.location.pathname;
//   // ✅ Remove OTP flag if not on /account or /login page
//   if (!currentUrl.includes("/account") && !currentUrl.includes("/login")) {
//     sessionStorage.removeItem("hasShownOtp");
//   }

//   if (window.location.hash.includes('login-password')) {
//     console.log('login-password');
//     sessionStorage.setItem("hasShownOtp", true);
//   } else {
//     const passwordSubmited = sessionStorage.getItem("passwordSubmited");
//     if (!passwordSubmited) {
//       sessionStorage.removeItem("hasShownOtp");
//     }
//   }

//   document.querySelector('.dropdown-menu .login-button')?.addEventListener('click', (event) => {
//     event.preventDefault();
//     window.location.href = '/account/login';
//     sessionStorage.removeItem("hasShownOtp");
//   })
// });

// Chat bot 
const liveChatEl = document.querySelectorAll('.live-chat__tigger');
liveChatEl?.forEach((each) => {
  each?.addEventListener('click', () => {
    const chatButton = document.querySelector('.dw-button');
    if (chatButton) {
      chatButton.click();
    }
  })
})